var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg9887193584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.334 8.333)",
    id: "ss9887193584_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 33.867 C 75 17.902 75 9.92 70.118 4.96 C 65.238 0 57.38 0 41.667 0 L 33.333 0 C 17.62 0 9.763 0 4.881 4.96 C 0 9.92 0 17.902 0 33.867 C 0 49.832 0 57.814 4.882 62.774 C 6.838 64.762 9.272 65.954 12.5 66.667",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.333 64.584 C 83.333 56.772 83.333 52.866 81.343 50.128 C 80.701 49.244 79.924 48.466 79.04 47.823 C 76.301 45.833 72.395 45.833 64.583 45.833 L 43.75 45.833 C 35.938 45.833 32.032 45.833 29.294 47.823 C 28.409 48.466 27.632 49.243 26.989 50.128 C 25 52.866 25 56.772 25 64.584 C 25 72.396 25 76.302 26.99 79.04 C 27.632 79.924 28.41 80.702 29.294 81.344 C 32.032 83.334 35.938 83.334 43.75 83.334 L 64.583 83.334 C 72.395 83.334 76.301 83.334 79.04 81.344 C 79.924 80.702 80.702 79.924 81.344 79.04 C 83.334 76.302 83.334 72.396 83.334 64.584 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.416 58.334 L 64.249 61.637 C 65.86 63.027 66.666 63.722 66.666 64.585 C 66.666 65.448 65.86 66.142 64.249 67.531 L 60.416 70.835 M 47.916 58.334 L 44.083 61.637 C 42.472 63.027 41.666 63.722 41.666 64.585 C 41.666 65.448 42.472 66.142 44.083 67.531 L 47.916 70.835 M 2.082 16.667 L 72.915 16.667",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg9887193584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWd);
export default __webpack_public_path__ + "static/media/wd.0da5273c33660943e1bca1f78d3a26b2.svg";
export { ForwardRef as ReactComponent };